import imperial from './imperial';
import metric from './metric';

const translations = {
  imperial,
  metric,
};

type UnitSystemKey = keyof typeof translations;
type TranslationKey = keyof typeof imperial;

const UNIT_SYSTEM: Record<UnitSystemKey, UnitSystemKey> = {
  imperial: 'imperial',
  metric: 'metric',
};

const defaultUnitLocale = imperial;

const getTranslatedUnitName = (
  key: string,
  localeUnitSystem: string = UNIT_SYSTEM.imperial
): string => {
  const currTranslation = translations[localeUnitSystem as UnitSystemKey] ?? defaultUnitLocale;
  return currTranslation[key as TranslationKey] ?? defaultUnitLocale[key as TranslationKey] ?? key;
};

export { getTranslatedUnitName, translations, UNIT_SYSTEM };
